module.exports = __webpack_public_path__ + "static/media/fvs_valve1_43.00466f0a.jpg";